/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { ReactComponent as StarIcon } from 'assets/images/gen-ai-image-landing/star.svg';
import styles from './ForEveryone.module.scss';

export default function ForEveryone() {
  return (
    <div className={styles.forEveryoneSection}>
      <div className={styles.verticalLine} />

      <div className={styles.content}>
        <div className={styles.decorativeStar}>
          <StarIcon />
        </div>

        <div className={styles.title}>
          For
        </div>

        <div className={styles.gradientText}>
          Everyone, any room, any style
        </div>

        <div className={styles.subtitle}>
          We do it all
        </div>
      </div>
    </div>
  );
}
